import * as React from 'react';
import { Button } from 'reactstrap';
import { useEffect, useState } from 'react';
import { Communicator } from '../../tools/Communication';
import { ContentSection } from '../../components/Layout/ContentSection';

type Region = {
  id: number;
  name: string;
  new: boolean | null;
};

export default function EditRegionPage() {
  const [regions, setRegions] = useState<Region[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    Communicator.Get('/Region/GetAllRegions', {})
      .then((response) => response.json())
      .then((newRegions: Region[]) => {
        [...newRegions].sort((a, b) => a.name.localeCompare(b.name));
        setRegions(newRegions);
      });
  }, []);

  async function saveRegions() {
    setIsLoading(true);
    try {
      console.log(JSON.stringify(regions));
      const result: Response = await Communicator.PostData(
        '/Region/SaveRegions',
        regions,
      );
      const newRegions: Region[] = await result.json();
      newRegions.sort((a, b) => a.name.localeCompare(b.name));
      setRegions(newRegions);
    } catch (e) {
      alert('Error saving config');
    }
    setIsLoading(false);
  }

  function onRegionNameChange(newName: string, id: number) {
    const newRegions = [...regions];
    const region = newRegions.find((r) => r.id === id);
    if (region != null) {
      region.name = newName;
      setRegions(newRegions);
    } else {
      throw new Error('Could not find region');
    }
  }

  function addRegion() {
    const max = Math.max(...regions.map((r) => r.id));
    const newRegions = [...regions];
    newRegions.push({ name: 'New Region', id: max + 1, new: true });
    setRegions(newRegions);
  }

  function removeRegion(id: number) {
    const newRegions = regions.filter((r) => !(r.new === true && r.id === id));
    setRegions(newRegions);
  }

  return (
    <ContentSection title="Edit Regions" collapsable={false}>
      {regions.map((region) => (
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            value={region.name}
            onChange={(e) => onRegionNameChange(e.target.value, region.id)}
            style={{ margin: '0.2em' }}
          />
          {region.new === true && (
            <Button
              size="sm"
              color="danger"
              style={{ margin: '0.2em' }}
              onClick={() => removeRegion(region.id)}
            >
              {' '}
              Delete
            </Button>
          )}
        </div>
      ))}
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Button
          color="secondary"
          style={{ margin: '0.2em' }}
          onClick={addRegion}
        >
          Add Region
        </Button>

        <Button
          color="primary"
          style={{ margin: '0.2em' }}
          onClick={saveRegions}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </ContentSection>
  );
}
